import { AutoStories, PlayLesson } from '@mui/icons-material';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import ReactHTMLParser from 'react-html-parser'

// Public site, no accounts - each lesson is its own URL (/article/:id) so it
// can be linked to directly from elsewhere, instead of per-user progress.
const Sidebar = () => {
  const { id } = useParams();
  const currentlyReading = Number(id);
  const posts = useSelector(state => state.app.posts);

  return (
    <Paper>
      <List>
        <ListItem>
          <ListItemText>
            <Typography fontWeight={600} variant="h6">Lessons</Typography>
          </ListItemText>
        </ListItem>
        {
          posts.map(post => (
            <ListItemButton
              key={post.id}
              component={Link}
              to={`/article/${post.id}`}
            >
              <ListItemIcon>
                {
                  post.id === currentlyReading ?
                  <AutoStories color="primary" /> :
                  <PlayLesson color="secondary" />
                }
              </ListItemIcon>
              <ListItemText>{ ReactHTMLParser(post.title.rendered) }</ListItemText>
            </ListItemButton>
          ))
        }
      </List>
    </Paper>
  )
}

export default Sidebar
